export const isAxiosErrorLike = (error) => {
  return Boolean(
    error &&
    (error.isAxiosError ||
      error.response ||
      error.request ||
      (error.config && (error.config.url || error.config.baseURL))),
  );
};

const safeString = (value) => {
  if (value == null) return "";
  try {
    return String(value);
  } catch {
    return "";
  }
};

export const getFriendlyErrorInfo = (error, options = {}) => {
  const fallbackMessage =
    options.fallbackMessage ||
    "Something went wrong. Please try again in a moment.";

  if (typeof error === "string") {
    return {
      title: "Error",
      message: error || fallbackMessage,
      details: "",
      status: undefined,
    };
  }

  const status = error?.response?.status;
  const method = safeString(error?.config?.method || "").toUpperCase();
  const url = safeString(error?.config?.url || "");

  const statusText = safeString(error?.response?.statusText || "");
  const serverMessage =
    safeString(error?.response?.data?.message) ||
    safeString(error?.response?.data?.error) ||
    safeString(error?.message);

  const detailsParts = [
    method && url ? `${method} ${url}` : url || method,
    status ? `HTTP ${status}${statusText ? ` ${statusText}` : ""}` : "",
  ].filter(Boolean);

  const details = detailsParts.join(" • ");

  if (!status) {
    return {
      title: "Network error",
      message:
        "Can’t reach the server right now. Check your connection and try again.",
      details: details || safeString(error?.message),
      status: undefined,
    };
  }

  if (status >= 500) {
    return {
      title: "Server error",
      message:
        "The server ran into a problem processing your request. Please try again shortly.",
      details,
      status,
    };
  }

  if (status === 401) {
    const errorCode = safeString(error?.response?.data?.errorCode || "");
    if (errorCode === "InvalidCredentials") {
      return {
        title: "Login failed",
        message: "Incorrect username or password.",
        details,
        status,
      };
    }
    return {
      title: "Signed out",
      message: "Your session has expired. Please sign in again.",
      details,
      status,
    };
  }

  if (status === 403) {
    return {
      title: "Not allowed",
      message: "You don’t have permission to perform this action.",
      details,
      status,
    };
  }

  if (status === 404) {
    return {
      title: "Not found",
      message: "That resource wasn’t found.",
      details,
      status,
    };
  }

  return {
    title: "Request failed",
    message: serverMessage || fallbackMessage,
    details,
    status,
  };
};
